import React from 'react'
import { useRef,useEffect } from 'react';

const PageTopbar = ({page,total}) => {
    const bar = useRef();
    useEffect(()=>{
        bar.current.style.width = ((page/total)*100)+"%";
    },[page])
  return (
    <div className='product_create_topbar_wrapper'>
      <div className='product_create_topbar_container'>
        <div className='product_create_topbar' ref={bar}></div>
      </div>
    </div>
  )
}

export default PageTopbar
